module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Testimonials"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black is-size-4"
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/#testimonials"
    }
  }, [_vm._v("📝 Testimonials")])], 1), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.testimonials), function(r) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('br'), _vm._v("⭐️⭐️⭐️⭐️⭐️ "), _c('a', {
      attrs: {
        "href": r.link
      }
    }, [_c('span', {
      staticClass: "time",
      domProps: {
        "innerHTML": _vm._s(r.time)
      }
    })]), _vm._v(" "), _c('br'), _vm._v("\""), _c('span', {
      domProps: {
        "innerHTML": _vm._s(r.review)
      }
    }, [_vm._v("\"")]), _vm._v(" "), _c('br'), _c('span', {
      staticClass: "author",
      domProps: {
        "innerHTML": _vm._s(r.name)
      }
    })])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c47b35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Testimonials.vue
// module id = 241
// module chunks = 0